import React from "react";

export const RevokeButton: React.FC<{ onClick: () => void; isVisible: boolean }> = ({
  onClick,
  isVisible,
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <button className="approve-btn" onClick={onClick}>
      Revoke
    </button>
  );
};
